export const LottieSettings = {
  label: 'Lottie',
  name: 'lottie',
  description: 'Overrides Image',
  component: 'select',
  options: [
    {
      label: 'Select Lottie File',
      value: '',
    },
    {
      label: 'Bust Your Bottleneck',
      value: 'bustYourBottleneck',
    },
    {
      label: 'Build Your Storefront',
      value: 'buildYourStorefront',
    },
    {
      label: 'Build Your Storefront V2',
      value: 'buildYourStorefrontV2',
    },
    {
      label: 'CRO Tools',
      value: 'croTools',
    },
    {
      label: 'Developer Tools',
      value: 'developerTools',
    },
    {
      label: 'Hydrogen Customizer',
      value: 'hydrogenCustomizer',
    },
    {
      label: 'Move Faster As A Team',
      value: 'moveFasterAsATeam',
    },
    {
      label: 'Pack Hydrogen Tree',
      value: 'packHydrogenTree',
    },
    {
      label: 'Share Assets & Learnings',
      value: 'shareAssetsAndLearning',
    },
    {
      label: 'Syncing Shopify',
      value: 'syncingShopify',
    },
    {
      label: 'Test & Optimize',
      value: 'testAndOptimize',
    },
    {
      label: 'Visually Headless',
      value: 'visuallyHeadless',
    },
  ],
};
